import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectTypeComponent } from './project-type/project-type.component';
import { CreateProjectComponent } from './create-project/create-project.component';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserComponent } from './user/user.component';
import { RoleComponent } from './role/role.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationsComponent } from './applications/applications.component';
import { NewProjectComponent } from './new-project/new-project.component';
import { SharedModule } from 'shared-library';
import { ApppermissionsPipe } from 'usermgmt';

const routes:Routes = [
  { path: '', component: CreateProjectComponent},
  {
    path: 'projects',
    component: CreateProjectComponent
  },
  {
    path: 'applications',
    component: ApplicationsComponent
  },
  {
    path: 'users',
    component: UserComponent
  },
  {
    path: 'roles',
    component: RoleComponent
  }
]
@NgModule({
  declarations: [
    ProjectTypeComponent,
    CreateProjectComponent,
    UserComponent,
    RoleComponent,
    LoginPageComponent,
    ApplicationsComponent,
    NewProjectComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,  
    ReactiveFormsModule,
    ApppermissionsPipe,
    SharedModule,
    RouterModule.forChild(routes),
  ]
})
export class ProjectCoreModule { }

